<ion-header>
    <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
    <h1>{{ "__TEST_ZOOM_MEETING_SDK__" | translate }}</h1>

    <button (click)="getSignature()">{{ "__TEST_JOIN_MEETING__" | translate }}</button>
    <button (click)="switchViews()">{{shareScreen ? "__TEST_SHOW_INTERACTIVE__":"__TEST_HIDE_INTERACTIVE__" | translate}}</button>

    <div id="meetingSDKElement" #meetingSDKElement>
        <!-- Zoom Meeting SDK Component View Rendered Here -->
    </div>

    <div class="zoom-layout">
        <div id="host-video">{{ "__TEST_HOST_VIDEO__" | translate }} <div id="host-video-container"></div></div>
        <div id="host-share-screen">
            {{ "__TEST_SHARE_SCREEN__" | translate }}
            <div id="host-share-screen-container"></div>

            <br>{{ "__TEST_TOOLBAR__" | translate }}
            <div id="host-toolbar-container"></div>
        </div>
        <div id="host-chat">{{ "__TEST_HOST_CHAT__" | translate }}<div id="meetingSDKChatElement" #meetingSDKChatElement></div></div>
    </div>




</ion-content>
